import { Player } from '@lottiefiles/react-lottie-player';
import { Backdrop } from '@mui/material';

import ErrorImg from '../lottie/error.json';
import LoadingImg from '../lottie/loading.json';
import SuccessImg from '../lottie/success.json';
import { LoadingStates } from '../context/loading-context.jsx';

export default function LoadingAnimation({ loading, setLoading }) {
    function handleEvent(event) {
        if (event === 'complete') {
            setLoading && setLoading(null);
        }
    }

    return (
        <Backdrop
            sx={{
                background: 'rgba(255, 255, 255, 0.70)',
                zIndex: () => 999999,
            }}
            open={loading !== null}
        >
            {loading === LoadingStates.SHOW && (
                <Player autoplay={true} loop={true} src={LoadingImg} style={{ height: '150px', width: '150px' }} />
            )}
            {loading === LoadingStates.SUCCESS && (
                <Player
                    autoplay={true}
                    loop={false}
                    src={SuccessImg}
                    onEvent={handleEvent}
                    style={{ height: '150px', width: '150px' }}
                />
            )}
            {loading === LoadingStates.FAILURE && (
                <Player
                    autoplay={true}
                    loop={false}
                    src={ErrorImg}
                    onEvent={handleEvent}
                    style={{ height: '150px', width: '150px' }}
                />
            )}
        </Backdrop>
    );
}
